@if (hasCollection()) {

  <app-horizontal-divider/>

  <div class="title-wrapper">
    <span class="title">{{ collectionTitle() }} </span><span class="count">({{ totalRecords() }} items)</span>

  </div>
  <div class="search-wrapper">
    <app-search-input
      placeholder="Search"
      [(ngModel)]="keywordModel"
      (ngModelChange)="searchInputChange()"
      theme="white"/>
    <app-sort
      (sortModelChange)="sortChange($event)"/>
  </div>

  <div class="collections-wrapper">
    @for (item of collectionItems(); track item.id) {

      @switch (item.type) {
        @case (TYPES.News) {
          <app-news-section
            [noLeftMargin]="true"
            [news]="item"/>
        }
        @case (TYPES.Publication) {
          <app-publication-card
            [noLeftMargin]="true"
            [hasDesc]="true"
            [publicationData]="item"/>
        }
        @default {
          <app-simple-card [item]="item"/>
        }
      }
    }

    @if (hasNoResults()) {
      <div class="empty-state">
        <div class="icon"><i class="icon-SearchDensity-1"></i></div>
        <div class="no-results">No results</div>
      </div>
    }
  </div>

  <div class="paginator-wrapper">
    <app-paginator
      (onPagination)="paginationChange($event)"
      [skip]="skip()"
      [take]="take()"
      [totalRecords]="totalRecords()"
      [actByRoute]="false"/>
  </div>


  <app-horizontal-divider/>


}
